
import { ENV } from '@/infrastructure/env-config';
import { clearAllCookie, delCookie, getCookie } from '@raft/utils';
import { BaseUser } from './base-user';
import { AuthUser, ProUserInfo } from './types';
import {
  BUGLY_LOGIN_STORAGE_KEY,
  BuglyEnv,
  genAvatar,
  genCookieName,
  TDS_PASSPORT_HOST,
  TDS_PASSPORT_PATH,
  TDS_SASS_TOKEN,
  TDS_SASS_UIN,
  TDS_TOKEN,
  TDS_USER_ID,
  TDS_USER_NAME,
} from './utils';

const defaultAuthInfo: AuthUser = {
  isLoggedIn: false,
};
/**
 * 不需要校验登录态的页面路由配置
 */
const noNeedCheckLoginList = [
  '/login',
  '/register',
  '/select-account',
  '/security',
  '/index/main',
  '/index/tds-main',
  '/index/rightly',
  '/',
  '/alert-notice',
  '/join',
];

export const PLATFORM = 'bugly';

export const ROOT_DOMAIN = ENV.isGlobal ? '.tds.tencent.com' : '.tds.qq.com';
export const APP_NAME = ENV.isGlobal ? 'buglySgp' : 'bugly';

/**
 * 删除passport种的cookie
 */
export function clearLoginCookies() {
  delCookie(genCookieName(TDS_TOKEN), '/', ROOT_DOMAIN);
  delCookie(genCookieName(TDS_SASS_TOKEN), '/', ROOT_DOMAIN);
  delCookie(genCookieName(TDS_SASS_UIN), '/', ROOT_DOMAIN);
  delCookie(genCookieName(TDS_USER_ID), '/', ROOT_DOMAIN);
  delCookie(genCookieName(TDS_USER_NAME), '/', ROOT_DOMAIN);
}

/**
 * 带登录态跳转到腾讯云
 * @param saasToken
 * @param target 腾讯云的目标地址
 */
export function jumpToTencentCloud(uin: string, saasToken: string, target: string) {
  const url = new URL('https://cloud.tencent.com/login/saas/jumplogin');
  url.searchParams.set('SaaSToken', saasToken);
  url.searchParams.set('s_url', target);
  url.searchParams.set('clientUA', navigator.userAgent);
  url.searchParams.set('platform', PLATFORM);
  url.searchParams.set('uin', uin);
  url.searchParams.set('ownerUin', uin);

  window.open(url.toString(), '_blank');
}

export default class ProUser implements BaseUser<ProUser> {
  onLogin(): boolean {
    return true;
  }
  logout(): void {
    const passportURL = TDS_PASSPORT_HOST[ENV.buglyEnv as BuglyEnv];
    localStorage.removeItem(BUGLY_LOGIN_STORAGE_KEY);
    // 这个只能清除当前域名的
    clearAllCookie();
    // 需要单独针对.tds.qq.com域下的清除
    clearLoginCookies();
    const currentUrl = encodeURIComponent(location.href);
    const redirectURL = new URL(passportURL);
    redirectURL.pathname = TDS_PASSPORT_PATH;
    redirectURL.searchParams.set('url', currentUrl);
    redirectURL.searchParams.set('app', APP_NAME);
    window.location.href = redirectURL.toString();
  }
  checkLogin(pathname: string): boolean {
    const authInfo = this.initUserInfo();
    const noNeedCheck = noNeedCheckLoginList.includes(pathname);
    // 检查登录态
    if (!noNeedCheck && !authInfo.isLoggedIn) {
      this.logout();
      return false;
    }

    return true;
  }
  // todo any
  initUserInfo(): AuthUser {
    try {
      const token = this.getBuglyToken();
      const saasToken = this.getSaasToken();
      return (token && saasToken) ? {
        isLoggedIn: true,
        token,
        saasToken,
        userInfo: this.getUserInfo() as ProUserInfo,
      } : defaultAuthInfo;
    } catch (e) {
      return defaultAuthInfo;
    }
  }
  getUserInfo(): ProUser | null {
    try {
      return JSON.parse(localStorage.getItem(BUGLY_LOGIN_STORAGE_KEY) as string) as ProUser;
    } catch (e) {
      return null;
    }
  }
  getAvatar(): string {
    const userName = this.getUserName();
    return genAvatar(userName);
  }

  public getUserName(): string {
    return decodeURIComponent(getCookie(genCookieName(TDS_USER_NAME)) || '');
  }

  public getUserId() {
    return getCookie(genCookieName(TDS_USER_ID)) || '';
  }

  public getSaasToken() {
    return getCookie(genCookieName(TDS_SASS_TOKEN)) || '';
  }

  public getBuglyToken() {
    return getCookie(genCookieName(TDS_TOKEN)) || '';
  }

  public getSassUin() {
    return getCookie(genCookieName(TDS_SASS_UIN)) || '';
  }
}
